import React from 'react';
import { connect } from 'react-redux';
import { withCookies } from 'react-cookie';
import _ from 'lodash';
import {ButtonBase, Tooltip} from '@mui/material';
import { Navigate } from './Navigate';
import { ChatWindow } from './ChatWindow';
import {__, getCustomizationKey} from '../functions';
import AssistantIcon from '@mui/icons-material/Assistant';
import { setUser } from '../actions';
import '../assets/styles/chat.css';

class Chat extends Navigate {
    state = {
    };

    render() {
        const { user, setUser } = this.props;

        if (_.isEmpty(user) || getCustomizationKey() !== '' || this.isDemo()) {
            // Nie sme prihlaseny
            return null;
        }

        return (
            <div className="chat">
                <Tooltip title={__('Chat s AI asistentom')}>
                    <ButtonBase
                        onClick={() => this.showDrawer('chat-window')}
                        className="chat__button"
                    >
                        <AssistantIcon />
                        <div>AI chat</div>
                    </ButtonBase>
                </Tooltip>
                {this.renderDrawer('chat-window', {
                    title: __('Chat s AI asistentom'),
                    content: props => <ChatWindow user={user} {...props} setUser={setUser} />,
                })}
            </div>
        );
    }
}

const stateToProps = ({ user }) => ({ user });

export default withCookies(connect(stateToProps, { setUser })(Chat));
